import React, { FC } from "react";
import { TableCell, TableRow, Typography } from "@material-ui/core";

type Props = {
  message: string;
};

const DPEmptyTable: FC<Props> = ({ message }) => (
  <TableRow>
    <TableCell
      colSpan={999}
      size="medium"
      align="center"
      style={{ paddingTop: 33, paddingBottom: 33 }}
    >
      <Typography variant="body1" align="center">
        {message}
      </Typography>
    </TableCell>
  </TableRow>
);

export default DPEmptyTable;
